var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSafeallianceLogoWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_58",
    "data-name": "Group 58",
    xmlns: "http://www.w3.org/2000/svg",
    width: 491.017,
    height: 84.455,
    viewBox: "0 0 491.017 84.455",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_60_",
    width: 5.425,
    height: 84.455,
    transform: "translate(250.893)",
    fill: "#ec1c24"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_58_",
    d: "M407.116,30.935l-.962,1.991a8.968,8.968,0,0,0-4.532-1.374c-1.853,0-3.3.686-3.3,2.265,0,3.708,9.407,1.786,9.407,7.828,0,3.3-2.953,4.806-6.18,4.806a9.539,9.539,0,0,1-6.454-2.334l.962-1.853a8.4,8.4,0,0,0,5.561,2.129c1.991,0,3.57-.755,3.639-2.4.069-4.059-9.336-1.991-9.269-7.964,0-3.227,2.746-4.532,5.837-4.532a9,9,0,0,1,5.287,1.441Z",
    transform: "translate(-123.815 -9.247)",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_56_",
    d: "M427.236,43.369a7.153,7.153,0,0,1-3.777,1.305c-2.472,0-4.262-1.441-4.262-4.806V30.254h-2.4V28.265h2.4V23.8h2.468v4.465h5.356v2.06h-5.356v9.133c0,2.06.824,2.815,2.265,2.815a4.628,4.628,0,0,0,2.677-.893Z",
    transform: "translate(-130.615 -7.458)",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_53_",
    d: "M451.638,37.951a8.524,8.524,0,1,1-8.524-8.445,8.056,8.056,0,0,1,8.524,8.445Zm-14.556,0a6.046,6.046,0,1,0,6.042-6.249,5.9,5.9,0,0,0-6.042,6.249Z",
    transform: "translate(-136.203 -9.251)",
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_50_",
    d: "M483.1,37.927a7.865,7.865,0,0,1-8.033,8.445,6.982,6.982,0,0,1-6.523-3.708v9.819H466V29.472h2.472v3.639A7.02,7.02,0,0,1,474.93,29.4a7.988,7.988,0,0,1,8.167,8.524Zm-2.541,0a6.012,6.012,0,1,0-12.015,0,6.012,6.012,0,1,0,12.015,0Z",
    transform: "translate(-146.033 -9.216)",
    fill: "#fff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_47_",
    d: "M519.679,43.81a7.443,7.443,0,0,1-6.18,2.746,5.212,5.212,0,0,1-5.7-5.149c0-2.953,2.334-4.806,6.316-4.806h5.492v-.962c0-2.472-1.51-3.913-4.532-3.913a9.3,9.3,0,0,0-5.356,1.922l-1.029-1.786a11.291,11.291,0,0,1,6.866-2.265c4.12,0,6.454,2.2,6.454,5.837V46.558h-2.4V43.81Zm0-3.227V38.592h-5.218c-2.815,0-4.262.893-4.262,2.677,0,1.853,1.51,3.089,3.846,3.089a5.5,5.5,0,0,0,5.634-3.769Z",
    transform: "translate(-159.13 -9.279)",
    fill: "#fff"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_44_",
    d: "M554.028,34.811A7.865,7.865,0,0,1,546,43.256a6.982,6.982,0,0,1-6.523-3.708v3.639H537V19.5h2.472V30.005a7.02,7.02,0,0,1,6.454-3.708,7.936,7.936,0,0,1,8.1,8.514Zm-2.541,0a6.014,6.014,0,1,0-12.015,0,6.014,6.014,0,1,0,12.015,0Z",
    transform: "translate(-168.282 -6.111)",
    fill: "#fff"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_42_",
    d: "M582.49,46.323h-2.472V42.546a6.5,6.5,0,0,1-6.385,3.913,5.936,5.936,0,0,1-6.316-6.523V29.5h2.472v9.681a4.348,4.348,0,0,0,4.668,4.737,5.535,5.535,0,0,0,5.492-6.18V29.5h2.472V46.323Z",
    transform: "translate(-177.791 -9.245)",
    fill: "#fff"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_40_",
    d: "M607.116,30.934l-.962,1.991a8.969,8.969,0,0,0-4.532-1.374c-1.853,0-3.3.686-3.3,2.265,0,3.708,9.407,1.786,9.407,7.828,0,3.3-2.953,4.806-6.18,4.806a9.538,9.538,0,0,1-6.454-2.334l.962-1.853a8.4,8.4,0,0,0,5.561,2.129c1.991,0,3.57-.755,3.639-2.4.069-4.059-9.336-1.991-9.269-7.964,0-3.227,2.746-4.532,5.837-4.532a9.133,9.133,0,0,1,5.287,1.441Z",
    transform: "translate(-186.49 -9.246)",
    fill: "#fff"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_37_",
    d: "M633.01,38.855H619.278a5.886,5.886,0,0,0,6.111,5.356,7.089,7.089,0,0,0,5.218-2.129l1.374,1.441a8.884,8.884,0,0,1-6.8,2.815,8.076,8.076,0,0,1-8.376-8.524,8.06,8.06,0,0,1,8.309-8.524C630.607,29.385,633.284,33.162,633.01,38.855Zm-2.265-2.06a5.251,5.251,0,0,0-5.63-5.277,5.738,5.738,0,0,0-5.9,5.277Z",
    transform: "translate(-193.295 -9.198)",
    fill: "#fff"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_35_",
    d: "M661.568,24.656v2.2h4.806v2.06h-4.806V43.121H659.1V28.839h-2.2V26.785h2.2V24.932a5.317,5.317,0,0,1,5.425-5.63,6.213,6.213,0,0,1,3.639,1.167l-1.031,1.991a4.565,4.565,0,0,0-2.541-.893,2.939,2.939,0,0,0-3.022,3.089Z",
    transform: "translate(-205.856 -6.048)",
    fill: "#fff"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_32_",
    d: "M688.538,37.95a8.524,8.524,0,1,1-8.524-8.445,8.092,8.092,0,0,1,8.524,8.445Zm-14.556,0a6.046,6.046,0,1,0,6.042-6.249,5.9,5.9,0,0,0-6.042,6.249Z",
    transform: "translate(-210.44 -9.25)",
    fill: "#fff"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_30_",
    d: "M705.172,33.249a6.292,6.292,0,0,1,6.052-3.846v2.541a5.551,5.551,0,0,0-6.042,5.425V46.3H702.7V29.472h2.472Z",
    transform: "translate(-220.208 -9.216)",
    fill: "#fff"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_27_",
    d: "M412.09,78.125H399.251a5.192,5.192,0,0,0,5.277,4.262,6.527,6.527,0,0,0,4.806-1.991l1.922,2.06a9.285,9.285,0,0,1-7,2.884,8.163,8.163,0,0,1-8.652-8.583,8.274,8.274,0,0,1,8.583-8.652C410.1,68.1,412.5,72.014,412.09,78.125Zm-3.227-2.677a4.349,4.349,0,0,0-4.737-4.394,4.816,4.816,0,0,0-4.944,4.394Z",
    transform: "translate(-123.983 -21.341)",
    fill: "#fff"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_25_",
    d: "M426.892,85.259,420.3,68.3h3.846l4.737,13.4,4.668-13.4h3.639l-6.523,16.959Z",
    transform: "translate(-131.71 -21.402)",
    fill: "#fff"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_22_",
    d: "M461.89,78.125H449.051a5.192,5.192,0,0,0,5.277,4.262,6.527,6.527,0,0,0,4.806-1.991l1.922,2.06a9.285,9.285,0,0,1-7,2.884,8.163,8.163,0,0,1-8.652-8.583,8.275,8.275,0,0,1,8.583-8.652C459.9,68.1,462.371,72.014,461.89,78.125Zm-3.158-2.677A4.349,4.349,0,0,0,454,71.054a4.816,4.816,0,0,0-4.944,4.394Z",
    transform: "translate(-139.589 -21.341)",
    fill: "#fff"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_20_",
    d: "M478.708,71.6a6.219,6.219,0,0,1,5.9-3.5v3.5a5.163,5.163,0,0,0-5.9,4.737V85.2H475V68.242h3.639v3.365Z",
    transform: "translate(-148.853 -21.344)",
    fill: "#fff"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_18_",
    d: "M499.876,87.626a5.654,5.654,0,0,1-5.492,4.059,5.874,5.874,0,0,1-3.913-1.441l1.579-2.815a3.811,3.811,0,0,0,2.2.824,2.884,2.884,0,0,0,2.61-1.853l.55-1.305L490.4,68.4h3.777l5.074,12.839L504,68.4h3.639Z",
    transform: "translate(-153.678 -21.436)",
    fill: "#fff"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_15_",
    d: "M533.616,76.692a8.861,8.861,0,1,1-8.857-8.583,8.321,8.321,0,0,1,8.857,8.583Zm-14,.069a5.194,5.194,0,1,0,5.218-5.492,5.086,5.086,0,0,0-5.22,5.492Z",
    transform: "translate(-161.671 -21.349)",
    fill: "#fff"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_13_",
    d: "M563.635,74.636V85.21H560V75.671a3.771,3.771,0,0,0-4.059-4.12,4.735,4.735,0,0,0-4.806,4.6v9.064H547.5V68.251h3.639v3.227a6.444,6.444,0,0,1,6.249-3.365,5.92,5.92,0,0,1,6.247,6.523Z",
    transform: "translate(-171.573 -21.354)",
    fill: "#fff"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_10_",
    d: "M592.39,78.125H579.551a5.192,5.192,0,0,0,5.277,4.262,6.527,6.527,0,0,0,4.806-1.991l1.922,2.06a9.285,9.285,0,0,1-7,2.884,8.163,8.163,0,0,1-8.652-8.583,8.274,8.274,0,0,1,8.583-8.652C590.4,68.1,592.8,72.014,592.39,78.125Zm-3.227-2.677a4.35,4.35,0,0,0-4.737-4.394,4.816,4.816,0,0,0-4.944,4.394Z",
    transform: "translate(-180.485 -21.341)",
    fill: "#fff"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_8_",
    d: "M25.816,80.17A39.311,39.311,0,0,1,0,70.146l2.884-5.7a35.867,35.867,0,0,0,23.07,9.336c10.574,0,17.166-4.394,17.166-11.467.069-9-8.652-11.536-17.921-14.282C14.694,44.878,3.846,41.651,3.846,28.88a14.93,14.93,0,0,1,6.316-12.427,28.662,28.662,0,0,1,17.1-4.739,40.608,40.608,0,0,1,21.217,5.973l-2.748,6.042a37.456,37.456,0,0,0-18.95-5.492c-9.681,0-15.654,3.846-15.654,10.024,0,8.727,8.583,11.329,17.714,14.075,10.643,3.227,21.629,6.523,21.629,19.638-.069,10.848-9.955,18.2-24.649,18.2Z",
    transform: "translate(0 -3.681)",
    fill: "#fff"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_5_",
    d: "M110.86,11.6h7.278l30.624,68.456h-7L133.931,62.34H94.725L86.9,80.054H80.1Zm2.746,8.033L97.54,56.23h33.782l-16.273-36.6Z",
    transform: "translate(-25.1 -3.636)",
    fill: "#fff"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_4_",
    d: "M195.4,11.6h42.982v6.18H201.85V43.941H234.6v6.111H201.854v30H195.4Z",
    transform: "translate(-61.233 -3.636)",
    fill: "#fff"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3_",
    d: "M273.3,11.6h45.936v6.18H279.754V42.291h35.292v6.18H279.754V74.014h40.795v6.042H273.3Z",
    transform: "translate(-85.645 -3.636)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSafeallianceLogoWhite);
export default __webpack_public_path__ + "static/media/safealliance-logo-white.dd2560de1d1f5bd2aa60a3429b781546.svg";
export { ForwardRef as ReactComponent };